/**
 * 출력물 날짜 포맷 유틸.
 *
 * 금액 포맷(formatMoney)은 글로벌몰 결제통화 정합을 위해 `printLabels.ts` 로 이전했다
 * (locale-aware Intl currency — 주문 locale 로 통화기호·자릿수 결정). 여기엔 날짜만 남는다.
 */

/** 날짜 표기 — `YYYY-MM-DD HH:mm`. 부재 시 '-'. */
export const formatDateTime = (iso: string | null | undefined): string => {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const pad = (n: number) => `${n}`.padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
    d.getHours(),
  )}:${pad(d.getMinutes())}`;
};
